import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import css from './Container.sass';

function Container(props) {
  var debug = props.debug,
      fluid = props.fluid,
      textAlign = props.textAlign,
      children = props.children,
      className = props.className;
  var classNames = cx(css.root, fluid && css.fluid, textAlign && css["text-align-".concat(textAlign)], debug && css.debug, className);
  return React.createElement("div", {
    className: classNames
  }, children);
}

Container.displayName = 'Container';
Container.propTypes = {
  /**
   * Custom class name
   */
  className: PropTypes.string,

  /**
   * Primary content
   */
  children: PropTypes.node,

  /**
   * Enable debug
   */
  debug: PropTypes.bool,

  /**
   * Container has no maximum width.
   */
  fluid: PropTypes.bool,

  /**
   * Align container text.
   */
  textAlign:
  /*#__PURE__*/
  PropTypes.oneOf(['left', 'center', 'right', 'justified'])
};
Container.defaultProps = {};
export { Container };